import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';


function ProfessorsLessons(props) {
  const { data: { month, hash } } = props;
  const [month2, setMonth] = useState(month);
  const infoPath = `/professors/month-lessons/info/${hash}?month=${month2}`;
  const [professor, setProfessor] = useState({});
  const [lessons, setLessons] = useState([]);
  const [lessonsTypesDict, setLessonsTypesDict] = useState({});

  function handleMonthChange(event) {
    event.persist();
    window.location.href = `/professors/month-lessons/${hash}?month=${event.target.value}`;
  }

  useEffect(() => {
    fetch(infoPath)
      .then((r) => r.json())
      .then((data) => {
        setLessonsTypesDict(data.lessonsTypesDict);
        setProfessor(data.professor);
        setLessons(data.lessons);
      })
      .catch(console.log);
  }, []);

  const totalHours = lessons.reduce((s, l) => s + l.duration, 0);

  function lessonAmount(lesson) {
    const lt = lessonsTypesDict[parseInt(lesson.lesson_type, 10)];
    if (!lt || typeof lt !== 'object') return 0;
    return (lt.charge * lesson.duration) - lt.commission - lt.commission_admin;
  }

  function numberWithPoint(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const totalAmount = lessons.reduce((s, l) => s + lessonAmount(l), 0);

  function getTypeName(lessonType) {
    const lt = lessonsTypesDict[parseInt(lessonType, 10)];
    if (!lt) return lessonType;
    return typeof lt === 'object' ? lt.name : lt;
  }

  return (
    <div className="pl-wrap">

        <div className="pl-top">
          <p className="pl-name">{professor.name}</p>
          <div className="pl-month-row">
            <span className="pl-month-label">Mes</span>
            <select className="pl-month-select" name="month" id="month" value={month2} onChange={handleMonthChange}>
              <option value="">Seleccione el mes</option>
              <option value="Marzo">Marzo</option>
              <option value="Abril">Abril</option>
              <option value="Mayo">Mayo</option>
              <option value="Junio">Junio</option>
              <option value="Julio">Julio</option>
              <option value="Agosto">Agosto</option>
              <option value="Septiembre">Septiembre</option>
              <option value="Octubre">Octubre</option>
              <option value="Noviembre">Noviembre</option>
              <option value="Diciembre">Diciembre</option>
            </select>
          </div>
        </div>

        <div className="pl-stats">
          <div className="pl-stat">
            <div className="pl-stat-value">{lessons.length}</div>
            <div className="pl-stat-label">Clases realizadas</div>
          </div>
          <div className="pl-stat">
            <div className="pl-stat-value">{totalHours}h</div>
            <div className="pl-stat-label">Horas totales</div>
          </div>
          <div className="pl-stat pl-stat-money">
            <div className="pl-stat-value">${numberWithPoint(totalAmount)}</div>
            <div className="pl-stat-label">Total ganado</div>
          </div>
        </div>

        <div className="pl-panel">
          {lessons.length === 0 ? (
            <div className="pl-empty">
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.4 }}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <p className="pl-empty-title">Sin clases registradas</p>
              <p className="pl-empty-sub">No hay clases para el mes seleccionado</p>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="pl-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Alumno</th>
                    <th>Hrs</th>
                    <th>Tipo</th>
                    <th>Materia</th>
                    <th>Monto</th>
                  </tr>
                </thead>
                <tbody>
                  {lessons.map((lesson) => (
                    <tr key={lesson.id}>
                      <td>{lesson.date}</td>
                      <td>{lesson.Student.name}</td>
                      <td><span className="pl-dur-badge">{lesson.duration}h</span></td>
                      <td><span className="pl-type-badge">{getTypeName(lesson.lesson_type)}</span></td>
                      <td>{lesson.lecture}</td>
                      <td className="pl-amount">${numberWithPoint(lessonAmount(lesson))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

      </div>
  );
}

export default hot(module)(ProfessorsLessons);
